import { Component, effect, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITaskBankPlannedTabKPI, ITasksMap, Tasks} from 'src/app/shared/models/tasks-planned';
import { TaskInfoFormatterService } from '../../../../../shared/services/task-info/task-info-formatter.service';
import { TaskInfoService } from 'src/app/shared/services/task-info/task-info.service';
import { DataAccessService } from 'src/app/shared/services/data-access/data-access.service';
import { Table } from 'primeng/table';
import { Popover } from 'primeng/popover';
import { TaskMovementService } from 'src/app/shared/services/operations/task-movement.service';
import { TBDataSteamType, TBTabName } from 'src/app/shared/entity/enums';
import { ColumnName, TaskState, TaskType } from 'src/app/shared/models/core';
import { TaskbankColumnService } from '../column-service/taskbank-column.service';
import { DataRepositoryService } from 'src/app/shared/services/data-repository/data-repository.service';
import { Navigation } from 'src/app/shared/entity/navigation';
import { AppConstants } from 'src/app/shared/entity/constants';
import { ConnectionService } from 'src/app/shared/services/connection/connection.service';
import { ErrorMessage, ErrorType } from 'src/app/shared/entity/error.const';
import { SortingService } from 'src/app/shared/services/operations/sorting.service';
import { SelectedPreferencesENUM } from 'src/app/shared/models/preference';
import { KeyValue } from '@angular/common';
import { SelectedTBRowKPI } from 'src/app/shared/entity/utility-interfaces';
import { StateUpdateService } from 'src/app/shared/services/state-update/state-update.service';
import { OrderIdColorPipe } from 'src/app/shared/pipe/OrderIdColor/order-id-color.pipe';
import { FilterService, MessageService } from 'primeng/api';
import { getEventsByTab, getServiceCodesByTab, IndicatorDef } from 'src/app/shared/entity/indicator.const';
import { TaskBankFilterStateService } from 'src/app/shared/services/task-bank-filter/task-bank-filter-state.service';


@Component({
    selector: 'app-planned',
    templateUrl: './planned.component.html',
    styleUrls: ['../../../../../shared/css/primeng-table.component.scss'],
    providers: [OrderIdColorPipe],
    standalone: false
})
export class PlannedComponent implements OnInit, OnDestroy{
  @Input() columns:any[]=[]
  plannedDataSource: any[] | null = null;

  visibleColumns:any[]=[]
  showTable: boolean = true;
  private currentPreferenceId: string = '';
  private readonly taskFilterField = 'task_filter_keys';
  private readonly taskFilterKeys = Array.from(
    new Set([
      ...getServiceCodesByTab(TBTabName.Planned).map((item) => item.key),
      ...getEventsByTab(TBTabName.Planned).map((item) => item.key),
    ])
  );
  plannedData: any[] = [];
  routeid: string = '';
  selectedRoute: [] = []
  event = false
  plannedSubscription: Subscription[] = [];
  additionalData:any={};
  header: string='';
  @ViewChild('dataTable') table: Table;
  @ViewChild('indicatorPanel') indicatorPanel: Popover;
  activeIndicators: IndicatorDef[] = [];
  displayItemDialog =false;
  plannedTasksKpi:ITaskBankPlannedTabKPI = {} as ITaskBankPlannedTabKPI;
  taskstate = TaskState;
  taskType = TaskType;
  selectedTaskType: string;
  selectedTaskId: string;
  navigation = Navigation;
  sortingImage: {previewImageSrc:string,thumbnailImageSrc:string}[] = [];
  showSortingGallery: boolean = false;

  customSortAppliedIconPath = '../../../../../../assets/image/sort_selected.svg';
  customSortIconPath = '../../../../../../assets/image/sort.svg';

  selectedIndicatorFilters: string[] = [];

  /**
   * This collection replicates the selectedTask list for later use in reseting the global lighting
   */
  selectedTaskMovelist:any=[];
  //getter and setter 
  get isCustomSort(): boolean{
    return this.sortingService.isCustomSort?? false;
  }
  // getter for select all value
  get isSelectAll() {
    return this.taskMovementService.isSelectedAll;
  }
  get showSelectedTaskKPI(): KeyValue<keyof SelectedTBRowKPI, string| number>[]{
    return this.taskMovementService.selectedTaskKPI;
  }
  
  get tbLegends(){
    return [...this.taskInfoService.gettaskBankLegends];
  }

  selectedTaskFilterServiceCode: string | null = null;
  selectedTaskFilterEvent: string | null = null;

  /**
   * Displays the indicator panel for a specific row, showing the active indicators
   * @param event The event that triggered the panel display
   * @param row The row data containing the indicators
   */
  showIndicatorPanel(event: Event, row: any): void {
    this.activeIndicators = row.indicators ?? [];
    this.indicatorPanel.toggle(event);
  }

  constructor(public taskInfoService: TaskInfoService
    , public taskInfoFormatterService:TaskInfoFormatterService
    , private readonly dataAccessService: DataAccessService
    , public taskMovementService: TaskMovementService
    , private readonly taskBankColumnService: TaskbankColumnService
    , private readonly dataRepositoryService: DataRepositoryService
    , private readonly connectionService: ConnectionService
    , private readonly messageService: MessageService
    , public readonly stateUpdateService: StateUpdateService
    , public readonly sortingService: SortingService
    , private readonly filterService: FilterService
    , private readonly taskBankFilterStateService: TaskBankFilterStateService
  ) {
    this.filterService.register('task-filter-any', (rowValue: string[] | undefined, filterValue: string[] | null) => {
      if (!filterValue?.length) return true;
      if (!Array.isArray(rowValue) || !rowValue.length) return false;
      return filterValue.some((key) => rowValue.includes(key));
    });
    this.taskMoveCountEffect();
    this.sortedTaskSelectionEffect();
    this.selectedColumnEffect();
    this.taskBankFilterSignalEffect();
  }

  ngOnInit(): void {
    this.plannedSubscription.push(this.dataAccessService.isPlannedSelected$.subscribe((plannedData: any) => {
      //check if custom sort is applied on the table
        if(this.sortingService.isCustomSortApplied && this.dataRepositoryService.plannedTbCollection.size){
          //for delta and for a new route selection or deselection, the below method checks the main collection.
          this.setPlannedData(this.sortingService.processCustomSortingWithDelta());
          this.sortingService.isCustomSort = true;
        }
        else{
          this.setPlannedData([...this.dataRepositoryService.plannedTbCollection.values()]);
        }
        this.taskMovementService.allowedTaskMoveData = [...this.dataRepositoryService.plannedTbCollection.values()].filter((f: any) => f.isMovementAllowed)
        this.plannedTasksKpi = this.taskInfoFormatterService.kpiCalculate(this.plannedData);
        //if new route is selected - select All should reset in table
        if(!plannedData?.isDeltaUpdate && this.taskMovementService.isSelectedAll) {
          this.taskMovementService.resetTaskMovement();
        }
    }));

    this.dataAccessService.kpiDeltaUpdates$.subscribe(
      (data:any)=>{
        if(data){
          /**Below method updates planned component */
          this.updateComponentData();
        }
      }
    )

    /**
     * KPI data subscription, to update planned tab if any route is route 
     */
    this.dataAccessService.kpiData$.subscribe(
      (data:any) => {
        if (data) {
          if(this.plannedData.length){
            this.taskInfoService.loadData();
          }
        }
      }
    )

    this.taskFromMapSubs$();
    this.tbResetClickedSubs$();
    this.polygonTaskSelectSubs$();
    this.polygonTaskDeselectSubs$();
    
  }

  ngAfterViewInit(){
    /**
     * Overriding the default behavior of primeNG table ResetScrollToTop() to maintain the current position 
     * of the scroll while table layout or its dataset observes any change.
     */
    if(this.table?.scroller){
      this.table.scroller.autoSize = false  
    } 
    this.applyTaskBankSelectionFilter();
  }

  taskBankFilterSignalEffect(): void {
    effect(() => {
      const taskFilterState = this.taskBankFilterStateService.taskBankFilterState();
      const isPlannedTab = this.taskInfoService.selectedTabName?.toLowerCase() === TBTabName.Planned.toLowerCase();

      if (!isPlannedTab) {
        this.selectedTaskFilterServiceCode = null;
        this.selectedTaskFilterEvent = null;
        this.applyTaskBankSelectionFilter();
        return;
      }

      this.selectedTaskFilterServiceCode = taskFilterState.serviceCodeKey;
      this.selectedTaskFilterEvent = taskFilterState.eventKey;
      this.applyTaskBankSelectionFilter();
    });
  }

  ngOnDestroy():void{
    if(this.plannedSubscription && this.plannedSubscription?.length) {
      this.plannedSubscription.forEach(item=>item.unsubscribe());
    }
  }

  selectedColumnEffect() {
    effect(() => {
      if(this.dataRepositoryService.tempSelectedUserColumnPreferences()) {
        const taskBankSelectedPreference = this.dataRepositoryService.tempSelectedUserColumnPreferences()?.[SelectedPreferencesENUM.TASKBANK];
        const newPreferenceId = taskBankSelectedPreference?.id ?? '';
        
        const preferenceChanged = this.currentPreferenceId !== newPreferenceId;
        this.currentPreferenceId = newPreferenceId;
        
        this.visibleColumns=this.taskBankColumnService.getVisibleColumns(ColumnName.Planned, taskBankSelectedPreference?.columnList??[])
        
        if (preferenceChanged) {
          this.resetTable();
        }
      }
      else {
        //set the default column list
        this.visibleColumns = this.taskBankColumnService.getVisibleColumns(ColumnName.Planned);
        if (this.currentPreferenceId !== '') {
          this.currentPreferenceId = '';
          this.resetTable();
        }
      }
    })
  }

  /**
   * Resets the table to apply new column configurations
   */
  resetTable() {
    this.showTable = false;
    setTimeout(() => {
      this.showTable = true;
      setTimeout(() => this.applyTaskBankSelectionFilter(), 0);
    }, 0);
  }

  /**
   * Subscription Method, subscribes on task selection from map
   */
  taskFromMapSubs$(){
    this.plannedSubscription.push(
      this.taskInfoService.isSelectedFromMap$.subscribe((res) => {
        if (res.isSelectedFromMap) {
          this.scrollToSelectedRow();
          this.setPlannedData([
            ...this.dataRepositoryService.plannedTbCollection.values(),
          ]);
        }
        if (this.taskMovementService.isSelectedAll) {
          this.sortingService.resetingCustomSorting();
        }
        let task = this.plannedData.find((f) => f.task_id === res.taskId);
        this.taskMovementService.handleTaskMoveWithClick(task);
      })
    );
  }

  /**
   * Subscription Method, subscribes on task bank reset button click
   */
  tbResetClickedSubs$(){
    this.plannedSubscription.push(
      this.taskMovementService.resetButtonClicked.subscribe((res) => {
        if (res) {
          const selectedTaskList:any = this.taskMovementService
            .selectedOptionsForTaskMove.length
            ? this.taskMovementService.selectedOptionsForTaskMove
            : this.selectedTaskMovelist;
          selectedTaskList?.forEach(
            (task:any) => {
              if(this.dataRepositoryService.plannedTbCollection.get(task.task_id)){
                this.dataRepositoryService.plannedTbCollection.set(task.task_id, {
                  ...(this.dataRepositoryService.plannedTbCollection.get(
                    task.task_id
                  ) ?? ({} as ITasksMap)),
                  isSelectedByMap: false,
                });
              }
            }
          );
          this.setPlannedData([
            ...this.dataRepositoryService.plannedTbCollection.values(),
          ]);
        }
      })
    );
  }

  /**NOTE 
   * Below commented code is PLANNED FOR PHASE 2 RELEASE (IPMA-3532) of Map-leaflet
   * 
   */
  /**
   * This subscription triggers from Map component when certains tasks are selected under drawn polygon
   * & it manages the task selection for task movement
   */
  polygonTaskSelectSubs$(){
    this.plannedSubscription.push(
      this.dataAccessService.polygonTaskSelection$.subscribe((selectedRows) => {
        if (selectedRows) {
          this.taskMovementService.taskSelectionFromMapPolygon(selectedRows);
          if (this.taskMovementService.isSelectedAll) {
            this.sortingService.resetingCustomSorting();
          }
          if (this.sortingService.isCustomSortApplied && this.dataRepositoryService.plannedTbCollection.size) {
            this.sortingService.isCustomSort = true;
          }
          else {
            this.setPlannedData([...this.dataRepositoryService.plannedTbCollection.values()]);
          }
          this.taskMovementService.allowedTaskMoveData = [...this.dataRepositoryService.plannedTbCollection.values()].filter((f: any) => f.isMovementAllowed)
        }
      })
    );
  }

  /**
   * This subscription triggers from Map component when certains tasks are deselected on delete polygon
   * & it manages the task deselection for task movement list
   */
  polygonTaskDeselectSubs$(){
    this.plannedSubscription.push(
      this.dataAccessService.polygonTaskDeselection$.subscribe((deSelectRows) => {
        if (deSelectRows) {
          deSelectRows.forEach((deselectTask:any)=>{
            if(deselectTask.isMovementAllowed){
              this.taskMovementService.handleMovementForTaskDeselection(deselectTask);
              this.taskMovementService.onTaskUnselection(deselectTask.task_id);
            }
          })
          if (this.taskMovementService.isSelectedAll) {
            this.sortingService.resetingCustomSorting();
          }
          if (this.sortingService.isCustomSortApplied && this.dataRepositoryService.plannedTbCollection.size) {
            this.sortingService.isCustomSort = true;
          }
          else {
            this.setPlannedData([...this.dataRepositoryService.plannedTbCollection.values()]);
          }
          this.taskMovementService.allowedTaskMoveData = this.plannedData.filter((f: any) => f.isMovementAllowed)
        }
      })
    );
  }

  //effect Methods
  /**
   * Method runs the effect on task selection
   */
  sortedTaskSelectionEffect() {
    effect(() => {
      if (this.sortingService.$sortedTasksForMovement().length) {
        //assign the new sorted data to computed's table data collector
        this.setPlannedData([
          ...this.sortingService.$sortedTasksForMovement(),
        ]);
      } else {
        this.setPlannedData([
          ...this.dataRepositoryService.plannedTbCollection.values(),
        ]);
      }
    });
  }

  private setPlannedData(data: ITasksMap[]): void {
    this.plannedData = this.decorateTaskFilterKeys(data);
    this.applyTaskBankSelectionFilter();
  }

  private applyTaskBankSelectionFilter(): void {
    const selectedKeys = [
      this.selectedTaskFilterServiceCode,
      this.selectedTaskFilterEvent,
    ].filter((key): key is string => !!key);

    this.table?.filter(selectedKeys, this.taskFilterField, 'task-filter-any');
  }

  private decorateTaskFilterKeys(data: ITasksMap[]): ITasksMap[] {
    return data.map((row) => ({
      ...row,
      [this.taskFilterField]: this.taskFilterKeys.filter(
        (key) => Boolean((row as unknown as Record<string, unknown>)[key])
      ),
    }));
  }

   /**
   * Method runs the effect on task selection count
   */
  taskMoveCountEffect() {
    effect(() => {
      if (this.taskMovementService.taskmoveCount()) {
        this.selectedTaskMovelist = [
          ...this.taskMovementService.selectedOptionsForTaskMove,
        ];
      }
    });
  }


  /**
   * This method scrolls the Planned table in task bank to the currently selected task from map
   */
  scrollToSelectedRow() {
    const currentSelection = Array.from(this.dataRepositoryService.highlightedTaskOnMap.values()).pop();
    const index = this.plannedData.findIndex(row => row.id === currentSelection)
    if(index!==-1){
      let scrollTo = index == 0? index : index-1;
      this.table.scrollToVirtualIndex(scrollTo);
    }
  }

  saveColumnWidth(event: any) {
    this.taskBankColumnService.saveColumnWidth(event, this.visibleColumns);
  }

  filterData($event:any) {
    this.table.filterGlobal($event?.target?.value??'', 'contains')
  }

  /**
   * Method calls the service method for sorting the dataset
   */
  setSelectedTaskSorting(){
    if(!this.sortingService.isCustomSortApplied){
      this.sortingService.setSelectedTaskSorting()
    }
    else{
      this.sortingService.resetingCustomSorting();
    }
  }

  /**
   * Method is called after PrimeNG's built-in sorting is complete
   * @param event sorting parameters 
   */
  onColumnSort(event: any) {
    if(this.dataRepositoryService.plannedTbCollection.size){
      this.sortingService.setFlagsOnSortingEvent(event);
    }
    if (this.taskMovementService.isSelectedAll) {
      this.taskMovementService.selectedOptionsForTaskMove = [...this.plannedData];
    }
  }

  /**
   * Method triggered on select All event, sets the flag and proceeses the task movement 
   * for all tasks
   * @param event select all checkbox click event
   */
  onSelectAllToggle(event:any){
    if (event.checked) {
      this.sortingService.resetingCustomSorting();
    }
    this.taskMovementService.onSelectAllToggle(event);
  }

  /**
   * Method runs on table row selection/deselection and updates flags and movement 
   * activities
   * @param plannedData task object from the table row which was selected
   */
  onTaskSelection(plannedData: any){
    if(plannedData.isMovementAllowed) {
      this.taskMovementService.onTaskSelection(plannedData);
    }
    if (this.taskMovementService.isSelectedAll) {
      this.taskMovementService.selectedOptionsForTaskMove = [...this.dataRepositoryService.plannedTbCollection.values()];
      this.sortingService.resetingCustomSorting();
    }
  }

  onTaskUnselection(plannedData: any) {
    // In map/landing view, deselecting a row must also remove its coordinate
    // highlight on the map (mirrors the highlight applied on selection).
    // Guard on highlightedTaskOnMap (the source of truth) so it works even when
    // the row copy's isSelectedByMap flag is stale after a re-render.
    if (
      (this.taskInfoService.router.url === this.navigation.MapLeaflet ||
        this.taskInfoService.router.url === this.navigation.Landing) &&
      this.dataRepositoryService.highlightedTaskOnMap.has(plannedData.task_id)
    ) {
      this.taskMovementService.updateHighlightingTasks(plannedData);
    }
    this.taskMovementService.onTaskUnselection(plannedData.task_id);
    if (this.taskMovementService.isSelectedAll) {
      this.sortingService.resetingCustomSorting();
      // Deselecting a row means all tasks are no longer selected, so clear the
      // select-all flag; otherwise the follow-up row-select handler re-selects
      // every task via the isSelectedAll branch in onTaskSelection.
      this.taskMovementService.isSelectedAll = false;
    }
  }

  openItemDialog(element: any, type: string): void {
    const hasItems = type === 'items' && element.item_count > 0;
    const hasGoods = type === 'goods' && element?.goods_count > 0;

    if (hasItems || hasGoods) {
      this.showItemList(element, type);
    }
  }
  showItemList(element: any, type: string) {
    this.header = type === 'goods' ? 'Goods' : 'Items';
    this.additionalData = {
      element: element,
      title: type === 'goods' ? 'Goods' : 'Items',
      type: type,
      tab: TBTabName.Planned
    };
    this.displayItemDialog = true;
  }
 
  handleTaskClick($event:any, plannedData: ITasksMap) {
    //part 1: select the task for movement 

    //check if task is restricted or not, then call the selection method in task movement service
    this.taskMovementService.handleTaskMoveWithClick(plannedData);
    //part 2: set the task highlighting information to Map
    this.taskMovementService.updateHighlightingTasks(plannedData);
    



    //to prevent the row click event to get triggerd after this method
    $event?.stopPropagation();
  }

  /**
   * Method updates the component data with latest value
   * from data repo collection
   */
  updateComponentData(){
    this.taskInfoService.setTaskBankCount(
      this.dataRepositoryService.plannedTbCollection,
      TBTabName.Planned
    );
    //check if any custom sorting on the table is applied at latest
    if (this.sortingService.isCustomSortApplied) {
      this.sortingService.setSelectedTaskSorting()
    } else {
      this.setPlannedData([ ...this.dataRepositoryService.plannedTbCollection.values(),
      ]);
    }
    this.plannedTasksKpi = this.taskInfoFormatterService.kpiCalculate(
      this.plannedData
    );
    if (!this.dataRepositoryService.plannedTbCollection.size) {
      this.taskInfoService.setupDataStream([], TBDataSteamType.Reset);
    }
  }
  /**
   * Opens the PBM Task Lookup page for the specific order ID.
   * @param pbm_order_id 
   */
   PBMlookup(pbm_order_id:string){
    this.taskInfoService.lookupPBMOrder(pbm_order_id)
  }
  

  /**
   * To show/hide Sorting gallery
   * @param $event: {pnItemId:string}
   */
  showImageDialog($event:{pnItemId:string}) {
    this.getSortingImages($event.pnItemId)
  }

  /**
   * Closes the dialog
   * 
   * @param $event - A boolean indicating whether to close the dialog (true) or not (false).
   */
  closeDialog($event: boolean) {
    this.taskInfoService.closeDialog($event);
  }

  /**\
   * updates the active tab by invoking activeTabSubscription.
   */
  refreshActiveTabData() {
    this.taskInfoService.activeTabSubscription();
  }

  /**
   * get the current dialog type from the updatePopup state in taskInfoService.
   * 
   * @returns The dialog type as a string, or an empty string if not set.
  */
  get DialogType() {
    return this.taskInfoService?.updatePopup?.dialogType ?? '';
  }

    /**
   * To get the sorting image for the item 
   * 
   * @param pnItemId 
   */
  getSortingImages(pnItemId: string) {
    this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `${AppConstants.GET_SORTING_IMAGES}?itemId=${pnItemId}`,
      directoryType: AppConstants.DP,
      responseType: 'json',
      isLoader: false
    }).subscribe({
      next: (res: any) => {
        if (res) {
          if (res?.images?.length) {
            this.sortingImage = res.images
              .map((image: any) => ({
                previewImageSrc: `data:image/jpeg;base64,${image?.imageBase64}`,
                thumbnailImageSrc: `data:image/jpeg;base64,${image?.thumbnailImage}`
              }));
            this.showSortingGallery = true;
          }
        }
      },
      error: (err) => {
        this.messageService.add({ severity: ErrorType.ERROR, summary: ErrorType.ERROR, detail: ErrorMessage.NOIMAGEFOUND });
      }
    });
  }

  /**
   * Indicates whether the update popup dialog should be shown.
   * 
   * @returns True if the popup should be visible; otherwise false.
   */
  get getShowPopup() {
    return this.taskInfoService?.updatePopup?.showPopup ?? false;
  }

  /**
   * Setter for controlling the visibility of the popup dialog.
   * Updates the `showPopup` property in the `taskInfoService` to reflect
   * the current visibility state of the dialog.
   * 
   * @param value - A boolean indicating whether the popup should be shown (true) or hidden (false).
   */
  set getShowPopup(value: boolean) {
    if (this.taskInfoService?.updatePopup) {
      this.taskInfoService.updatePopup.showPopup = value;
    }
  }

  /**
   * set selected task details and show state update popup
   * @param task selected task details
   */
  openStatePopup(task: Tasks) {
    this.selectedTaskType = task.task_type;
    this.selectedTaskId = task.task_id;
    this.stateUpdateService.showStatePopup = true;
  }
}
